module.exports = __webpack_public_path__ + "img/saishianpai-icon-3.cb0369f1.png";